import { ReactElement, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { companyAccessTokenAtom, isQueryModeAtom } from "../store";

type Props = {
  defaultPath: string;
};

export function useQueryLoginRedirect({ defaultPath }: Props): ReactElement {
  const { i18n } = useTranslation();
  const [, setQueryLogin] = useAtom(isQueryModeAtom);
  const [, setCompanyAccessToken] = useAtom(companyAccessTokenAtom);

  const search = useLocation().search;
  const companyAccessTokenInfo = new URLSearchParams(search).get(
    "company_token",
  );

  useEffect(() => {
    return () => {
      if (companyAccessTokenInfo) {
        setCompanyAccessToken(companyAccessTokenInfo);
        setQueryLogin(true);
      }
    };
  }, [companyAccessTokenInfo, setQueryLogin, setCompanyAccessToken]);

  const to = companyAccessTokenInfo
    ? `/${i18n.resolvedLanguage}/query-login`
    : defaultPath;

  return <Navigate replace to={to} />;
}
